import * as React from "react";
import { useState, useEffect } from "react";
import { CHEVRON_DOWN, CHEVRON_UP } from "../../../Constants";
import {
    shouldCardCollapse,
    toggleCardShouldCollapse,
} from "../../../Helpers/localStorage";
import { OutotecIcons } from "../Icons/";

interface CollapsibleCardProps {
    title: string;
    content: JSX.Element;
    collapsed?: boolean;
    className?: string;
}

export default function CollapsibleCard(props: CollapsibleCardProps) {
    const [collapsed, setCollapsed] = useState<boolean>(false);

    useEffect(() => {
        let shouldCollapse: boolean = shouldCardCollapse(
            props.title.toLocaleLowerCase()
        );

        if (
            ["change requests"].indexOf(props.title.toLocaleLowerCase()) !== -1
        ) {
            shouldCollapse = true;
        }

        if (props.collapsed) {
            shouldCollapse = props.collapsed;
        }
        setCollapsed(shouldCollapse);
    }, [props.title, props.collapsed]);

    const collapse = (): void => {
        setCollapsed(!collapsed);
        toggleCardShouldCollapse(props.title.toLocaleLowerCase());
    };

    const collapseButton = (): JSX.Element => {
        return (
            <span
                className="card-header-collapse-icon"
                onClick={() => collapse()}
            >
                {collapsed && <OutotecIcons type={CHEVRON_DOWN} />}
                {!collapsed && <OutotecIcons type={CHEVRON_UP} />}
            </span>
        );
    };

    const cardClassName: string = `card-block ${
        collapsed ? "card-block-hide" : ""
    }`;
    return (
        <div className={`card ${props.className ? props.className : ""}`}>
            <h2 className="card-header">
                <span className="card-header-text">{props.title}</span>
                {collapseButton()}
            </h2>
            <div className={cardClassName}>{props.content}</div>
        </div>
    );
}
